import React, { useState } from "react";
import { showAlert } from "./DynamicComp/Alert"; 

const ReturnOrderModal = ({ onClose, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");

  const returnReasons = [
    "Item damaged or defective",
    "Wrong item delivered",
    "Quality not as expected",
    "Size/fit issue",
    "Changed my mind",
    "Other",
  ];

  const handleConfirm = () => {
    if (!reason) {
      showAlert({
        type: 'warning',
        message: 'Please select a reason for return',
        title: 'warning',
      });
      return;
    }

    const finalReason = reason === "Other" ? otherReason : reason;

    if (reason === "Other" && !finalReason.trim()) {
      showAlert({
        type: "warning",
        message: "Please specify your reason in the text box",
        title: "warning"
      });
      return;
    }

    onConfirm(finalReason);
  };

  return (
    // Modal Backdrop
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      
      {/* Modal Content */}
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h3 className="text-xl font-bold mb-4">Return Order</h3>
        <p className="text-gray-600 mb-6">
          Please select a reason for returning your order.
        </p>

        {/* Reason Selection */}
        <div className="space-y-4">
          {returnReasons.map((r) => (
            <label key={r} className="flex items-center space-x-3 cursor-pointer">
              <input
                type="radio"
                name="returnReason"
                value={r}
                checked={reason === r}
                onChange={() => setReason(r)}
                className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <span className="text-gray-700">{r}</span>
            </label>
          ))}

          {/* Textarea for "Other" reason */}
          {reason === "Other" && (
            <textarea
              className="w-full mt-2 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
              rows="3"
              placeholder="Please specify your reason..."
              value={otherReason}
              onChange={(e) => setOtherReason(e.target.value)}
              autoFocus
            />
          )}
        </div>

        {/* Action Buttons */}
        <div className="mt-8 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 font-semibold transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={handleConfirm}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-semibold transition-colors"
          >
            Confirm Return
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReturnOrderModal;
